<template>
  <NuxtLayout>
    <VideoHeader v-if="page?.video_url" class="videoHeader--Homepage">
      <ReservationPanel searchButton :key="$route.fullPath" />
    </VideoHeader>
    <HeroHeader v-else class="heroHeader--Homepage">
      <ReservationPanel searchButton :key="$route.fullPath" />
    </HeroHeader>
  
    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  })
  // do podataka za page se dolazi preko propa "page"
  const props = defineProps({
    page: {
      type: Object
    }
  })
  
  const { initialData, socialNetworks } = useSetup();
  const envVariables = useRuntimeConfig();

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })

  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "Aminess",
    "alternateName": "Aminess d.d.",
    "url": `${ envVariables.public.domain || '' }/`,
    "email": `${ initialData?.value?.contact?.email || '' }`,
    "telephone": `${ initialData?.value?.contact?.phone_number || '' }`,
    "logo": `${ envVariables.public.domain || '' }/resources/images/icons/logo.svg`,
    "sameAs": [
      ...socialNetworks.value.map((item) => item.href),
    ],
  }))

  useJsonld(() => ({
    "@context": "http://schema.org",
    "@type": "WebSite",
    "name" : "Aminess Hotels & Resorts",
    "url": `${ envVariables.public.domain || '' }/`,
  }))
</script>